<template>
  <div :class="$style.container">
    <div :class="$pgCTStyle.headerContainer">
      <!-- <div v-if="showAllGroupsCTA" :class="$style.titleEmptyContainer"></div> -->
      <div :class="$pgCTStyle.title">{{ computedTitle }}</div>
      <div :class="$pgCTStyle.headerRightCTAs">
        <PGHeaderActionButton
          v-if="showAllGroupsCTA"
          :text="$t('all-groups')"
          :clickFunction="showAllGroupsChats"
          backBg="#000000"
          frontBg="#676767"
          textColor="#ffc642"
          :button-width="isMobile ? '70px' : isTablet ? '72px' : '86px'"
        />
      </div>
    </div>
    <div :class="$style.chatContainer" ref="chatContainer">
      <!-- <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div>
      <div>body - {{ this.badWordsFilter.clean("fucking idiot!!") }}</div> -->
      <div
        v-for="message in messages"
        :key="message.docId ?? `${message.userId}-${message.createdAt?.seconds ?? message.createdAt}`"
        :class="[$style.chatMessage, message.userId == user.id ? $style.sentMessage : null]"
      >
        <img
          loading="lazy"
          v-if="message.userId != user.id"
          :src="message.userAvatar || defaultAvatar"
          :alt="message.userName"
          :class="$style.chatMessageUserAvatar"
        />
        <div
          :class="[
            $style.messageBox,
            message.userId == user.id ? $style.sentMessageBox : $style.receivedMessageBox,
            message.isHost && $style.hostMessageBox,
          ]"
        >
            <div :class="$style.chatMessageUser" v-if="message.userId != user.id">
              <div :class="$style.chatMessageUserName">~ {{ message.userName }}</div>
              <div v-if="message.isHost" :class="$style.chatHostLabel">
                {{ $t("host") }}
              </div>
              <div v-else-if="message.isModerator" :class="$style.chatHostLabel">
                {{ $t("moderator") }}
              </div>
            </div>
          <div :class="$style.chatMessageText">{{ message.textClean ?? message.text }}</div>
          <!-- <div :class="$style.chatMessageText">{{ this.badWordsFilter.clean(message.text) }}</div> -->
          <div :class="$style.chatMessageTime">{{ formatTimestamp(message.createdAt) }}</div>
        </div>
      </div>
    </div>
    <div v-if="!readOnly" :class="$style.sendContainer">
      <div :class="$style.sendInnerContainer">
        <div :class="$style.textBox">
          <input
            type="text"
            :placeholder="$t('type-message')"
            v-model="textMessage"
            @keydown.enter.exact.prevent="handleSendMessage"
            @keydown.shift.enter.stop
            autocomplete="off"
          />
        </div>

        <!-- <div title="Send message" :class="$style.sendButton" @click="this.handleSendMessage"> -->
        <div
          :title="$t('send-message')"
          :class="$style.sendButton"
          :aria-disabled="sendingMessage || !textMessage.trim()"
          :style="sendingMessage || !textMessage.trim() ? 'opacity:.5;pointer-events:none' : ''"
          @click="this.handleSendMessage"
        >

          <img :src="sendIcon" alt="sendMessage" />
        </div>
      </div>
      <div v-if="sendingMessage" :class="$style.messageSendLoaderContainer">
        <img :src="messageSendLoaderGif" alt="message-send-loader" />
      </div>
    </div>
  </div>
</template>

<script>
import styles from "@/css/ChatBox.module.css";
import playGameComponentsTemplateStyles from "@/css/PlayGameComponentsTemplate.module.css";
import globalStyles from "@/css/global.module.css";
import SendIcon from "@/assets/icons/paper-plane.svg";
import MessageSendLoaderGif from "@/assets/gifs/message-send-loader.svg";
import { Filter } from "bad-words";
import { Timestamp } from "firebase/firestore";
// import UtilButton from "../util/UtilButton.vue";
import { defaultAvatar } from "@/utils/data";
import PGHeaderActionButton from "../buttons/PGHeaderActionButton.vue";
import useDeviceType from "@/utils/useDeviceType";

const NOOP = () => {};
const device = useDeviceType();

export default {
  components: { PGHeaderActionButton },
  name: "ChatBox",
  props: {
    canOpenAllGroups: {
    type: Boolean,
    required: false,
    default: false,
  },
    group: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    messages: {
      type: Array,
      required: true,
      default: () => [],
    },
    user: {
      type: Object,
      required: true,
    },
    sendMessage: {
      type: Function,
      required: true, // Ensure it's a required function
    },
    openAllGroupsChats: {
      type: Function,
      required: false,
      default: NOOP,
    },
    title: {
      type: String,
      required: false,
      default: "",
    },
    isHost: {
      type: Boolean,
      required: false,
      default: false,
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      sendIcon: SendIcon,
      textMessage: "",
      badWordsFilter: new Filter(),
      messageSendLoaderGif: MessageSendLoaderGif,
      sendingMessage: false,
      defaultAvatar: defaultAvatar,
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $globalStyle() {
      return globalStyles;
    },
    $pgCTStyle() {
      return playGameComponentsTemplateStyles;
    },
    showAllGroupsCTA() {
      return this.openAllGroupsChats !== NOOP && this.canOpenAllGroups;
    },
    computedTitle() {
      return this.title || this.$t("group-chat");
    },
    width() {
      return device.width.value;
    },
    height() {
      return device.height.value;
    },
    isMobile() {
      return device.isMobile.value;
    },
    isTablet() {
      return device.isTablet.value;
    },
    isDesktop() {
      return device.isDesktop.value;
    },
  },
  methods: {
    async handleSendMessage() {
      if (this.readOnly) {
        return;
      }

      if (!this.textMessage || !this.textMessage.trim()) {
        return;
      }

      if (!this.group || !this.group.id) {
        console.error("Cannot send message: invalid group");
        return;
      }

      this.sendingMessage = true;

      try {
        // Call the sendMessage function passed as a prop
        await this.sendMessage(this.textMessage, this.group.id);

        this.textMessage = "";
        // this.scrollToBottom();
        this.scrollToBottom(true);
      } catch (error) {
        console.error("Failed to send message:", error);
      } finally {
        this.sendingMessage = false;
      }
    },
    // scrollToBottom() {
    //   this.$nextTick(() => {
    //     const chatContainer = this.$refs.chatContainer;
    //     if (chatContainer) {
    //       requestAnimationFrame(() => {
    //         chatContainer.scrollTo({
    //           top: chatContainer.scrollHeight + 100, // Extra offset ensures full scrolling
    //           behavior: "smooth",
    //         });
    //       });
    //     }
    //   });
    // },
    isNearBottom(el, threshold = 80) {
      return el.scrollHeight - el.clientHeight - el.scrollTop <= threshold;
    },
    scrollToBottom(force = false) {
      this.$nextTick(() => {
        const el = this.$refs.chatContainer;
        if (!el) return;
        if (!force && !this.isNearBottom(el)) return; // respect reader
        requestAnimationFrame(() => {
          el.scrollTo({ top: el.scrollHeight + 100, behavior: "smooth" });
        });
      });
    },
    formatTimestamp(timestamp) {
      if (timestamp instanceof Timestamp) {
        const date = timestamp.toDate();
        return date.toLocaleString(); // This will format the date in a human-readable format
      } else {
        return timestamp; // In case timestamp is already a string or other format
      }
    },
    showAllGroupsChats() {
      // Placeholder for showing all group chats functionality
      this.openAllGroupsChats();
    },
  },
  mounted() {
    this.scrollToBottom();
  },
  beforeUnmount() {},
  watch: {
    // messages: {
    //   deep: true,
    //   handler() {
    //     this.$nextTick(() => {
    //       this.scrollToBottom();
    //     });
    //   },
    // },
    "messages.length"() {
      this.$nextTick(this.scrollToBottom);
    },
  },
};
</script>

<style></style>
